import { render } from "./TrashBrand.vue?vue&type=template&id=83620f28"
import script from "./TrashBrand.vue?vue&type=script&lang=js"
export * from "./TrashBrand.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafepayam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__